import { Permissions } from '@/constants/roles-permissions'

// Define the pages in order of priority based on sidebar-data.ts
export const navigationPages = [
  { url: '/employee-portal', permission: Permissions.EmployeePortal },
  { url: '/employees', permission: Permissions.EmployeeView },
  { url: '/banned-employees', permission: Permissions.EmployeeBannedView },
  { url: '/profile-dashboard', permission: Permissions.EmployeeView },
  { url: '/accounting-transaction', permission: Permissions.AccountingTransactionView },
  { url: '/leave-tracking', permission: Permissions.LeaveView },
  { url: '/diligent-employees', permission: Permissions.LeaveView },
  { url: '/holiday-setting', permission: Permissions.HolidayView },
  { url: '/employee-assets-dashboard', permission: Permissions.EmployeeAssetView },
  { url: '/employee-assets', permission: Permissions.EmployeeAssetView },
  { url: '/employee-gifts', permission: Permissions.EmployeeGiftView },
  { url: '/labor-contracts', permission: Permissions.LaborContractView },
  { url: '/insurance-dashboard', permission: Permissions.LaborContractView },
  { url: '/labor-contract-dashboard', permission: Permissions.LaborContractView },
  { url: '/dormitory-hierachy', permission: Permissions.DormitoryView },
  { url: '/dormitory-management', permission: Permissions.DormitoryView },
  { url: '/file-storage', permission: Permissions.FileStorageView },
  { url: '/users', permission: Permissions.UserView },
  { url: '/roles', permission: Permissions.RoleView },
  { url: '/companies', permission: Permissions.CompanyView },
  { url: '/employee-groups', permission: Permissions.EmployeeGroupView },
  { url: '/assets', permission: Permissions.AssetView },
  { url: '/user-activities', permission: Permissions.UserActivityView },
  { url: '/user-sessions', permission: Permissions.UserActivityView },
  { url: '/settings/profile', permission: 'personal.view' }, // Personal profile access for all users
]

/**
 * Get the default navigation URL based on user permissions
 * @param userPermissions - Array of permission names
 * @param hasPermissionFn - Function to check if user has permission (fallback)
 * @returns The URL of the first accessible page
 */
export const getDefaultNavigationUrl = (
  userPermissions?: string[], 
  hasPermissionFn?: (permission: string) => boolean
): string => {

  // Check if user has Employee Portal permission first
  const hasEmployeePortalPermission = userPermissions?.includes('employee.portal') || 
    hasPermissionFn?.('employee.portal');
  
  if (hasEmployeePortalPermission) {
    return '/employee-portal';
  }

  // If userPermissions is provided, use it directly
  if (userPermissions) {
    for (const page of navigationPages) {
      if (userPermissions.includes(page.permission)) {
        return page.url;
      }
    }
  } else if (hasPermissionFn) {
    // Fallback to hasPermissionFn if no userPermissions provided
    for (const page of navigationPages) {
      if (hasPermissionFn(page.permission)) {
        return page.url;
      }
    }
  }

  // Fallback to employees page if no permissions found
  return '/employees';
} 